let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aWjio")).then(() => parcelRequire('65bRZ'));